import { Table as RadixTable } from "@radix-ui/themes";
import { FC, JSX, ReactNode } from "react";

export type TableProps<T> = {
  header?: Array<ReactNode>;
  items: Array<T>;
  tableBodyRenderer: (item: T, index: number) => ReactNode;
};

export const Table = <T,>(props: TableProps<T>): JSX.Element => {
  const { header, items, tableBodyRenderer } = props;

  const tableHead = header?.map((headerCell, index) => (
    <RadixTable.ColumnHeaderCell key={index}>
      {headerCell}
    </RadixTable.ColumnHeaderCell>
  ));

  const tableBody = items.map((item, index) => tableBodyRenderer(item, index));

  return (
    <RadixTable.Root variant="surface">
      {tableHead && (
        <RadixTable.Header>
          <RadixTable.Row>{tableHead}</RadixTable.Row>
        </RadixTable.Header>
      )}

      <RadixTable.Body>{tableBody}</RadixTable.Body>
    </RadixTable.Root>
  );
};

type WithChildren = {
  children?: ReactNode;
};
export const TableRow: FC<WithChildren> = (props) => {
  return <RadixTable.Row>{props.children}</RadixTable.Row>;
};

export const TableCell: FC<WithChildren> = (props) => {
  return <RadixTable.Cell>{props.children}</RadixTable.Cell>;
};
